import React, { useEffect, useState } from 'react';
import api from '../services/api';
import Toast from '../components/Toast';
import { filtreazaCantitate, normalizeazaNumar, formatCantitate } from '../utils/format';

const UNITATI = ['buc', 'mp', 'ml', 'kg', 'l'];

export default function Materiale() {
  const [grupuri, setGrupuri] = useState({ magazii: [], faraStoc: [] });
  const [extinse, setExtinse] = useState(new Set()); // magazieId-uri deschise ('faraStoc' pt grupul special)
  const [showModal, setShowModal] = useState(false);
  const [editId, setEditId] = useState(null);
  const [codEditat, setCodEditat] = useState('');
  const [form, setForm] = useState({ denumire: '', um: 'buc', pragAlerta: 0, pretCurent: '' });
  const [toast, setToast] = useState(null);
  const [loading, setLoading] = useState(true);

  function incarca() {
    setLoading(true);
    api.get('/api/materiale/pe-magazii').then(res => setGrupuri(res.data)).finally(() => setLoading(false));
  }

  useEffect(incarca, []);

  function toggleGrup(cheie) {
    setExtinse(prev => {
      const nou = new Set(prev);
      if (nou.has(cheie)) nou.delete(cheie); else nou.add(cheie);
      return nou;
    });
  }

  const toateChile = [...grupuri.magazii.map(g => g.magazieId), ...(grupuri.faraStoc.length > 0 ? ['faraStoc'] : [])];
  const totExtins = toateChile.length > 0 && toateChile.every(c => extinse.has(c));

  function toggleToate() {
    setExtinse(totExtins ? new Set() : new Set(toateChile));
  }

  function deschideNou() {
    setEditId(null);
    setCodEditat('');
    setForm({ denumire: '', um: 'buc', pragAlerta: 0, pretCurent: '' });
    setShowModal(true);
  }

  function deschideEditare(m) {
    setEditId(m.id);
    setCodEditat(m.cod);
    setForm({ denumire: m.denumire, um: m.um, pragAlerta: m.pragAlerta, pretCurent: m.pretCurent ?? '' });
    setShowModal(true);
  }

  async function salveaza(e) {
    e.preventDefault();
    try {
      const payload = {
        ...form,
        pragAlerta: normalizeazaNumar(form.pragAlerta) || 0,
        pretCurent: form.pretCurent === '' ? null : normalizeazaNumar(form.pretCurent)
      };
      if (editId) await api.put(`/api/materiale/${editId}`, payload);
      else await api.post('/api/materiale', payload);
      setToast({ message: 'Salvat cu succes', type: 'ok' });
      setShowModal(false);
      incarca();
    } catch (err) {
      setToast({ message: err.response?.data?.error || 'Eroare la salvare', type: 'error' });
    }
  }

  async function dezactiveaza(id) {
    if (!window.confirm('Dezactivezi acest material?')) return;
    await api.delete(`/api/materiale/${id}`);
    incarca();
  }

  function randMaterial(m) {
    return (
      <tr key={m.id}>
        <td>{m.cod}</td>
        <td>{m.denumire}</td>
        <td>{m.um}</td>
        {m.cantitate !== undefined && <td>{formatCantitate(m.cantitate)} {m.um}</td>}
        <td>{m.pragAlerta > 0 ? formatCantitate(m.pragAlerta) : <em>fara alerta</em>}</td>
        <td>{m.pretCurent != null ? `${formatCantitate(m.pretCurent)} lei` : <em>-</em>}</td>
        <td>
          <button className="btn-edit" onClick={() => deschideEditare(m)}>Editeaza</button>{' '}
          <button className="btn-delete" onClick={() => dezactiveaza(m.id)}>Dezactiveaza</button>
        </td>
      </tr>
    );
  }

  return (
    <div>
      <h1>Nomenclator materiale</h1>
      <div className="toolbar">
        <button className="btn-add" onClick={deschideNou}>+ Material nou</button>{' '}
        <button type="button" className="btn secondary" onClick={toggleToate}>
          {totExtins ? 'Restrange tot' : 'Extinde tot'}
        </button>
      </div>

      {loading ? <p>Se incarca...</p> : (
        <div className="card">
          {grupuri.magazii.map(g => (
            <div key={g.magazieId} style={{ marginBottom: 10 }}>
              <div onClick={() => toggleGrup(g.magazieId)}
                style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 8, padding: '8px 4px', fontWeight: 600, borderBottom: '1px solid #eee' }}>
                <span>{extinse.has(g.magazieId) ? '\u25be' : '\u25b8'}</span>
                <span>{g.magazieCod ? `${g.magazieCod} - ` : ''}{g.magazieNume}</span>
                <span style={{ fontWeight: 400, color: '#888', fontSize: 13 }}>({g.materiale.length} materiale)</span>
              </div>
              {extinse.has(g.magazieId) && (
                <table>
                  <thead>
                    <tr><th>Cod</th><th>Denumire</th><th>UM</th><th>Stoc aici</th><th>Prag alerta</th><th>Pret curent</th><th></th></tr>
                  </thead>
                  <tbody>{g.materiale.map(randMaterial)}</tbody>
                </table>
              )}
            </div>
          ))}

          {grupuri.faraStoc.length > 0 && (
            <div>
              <div onClick={() => toggleGrup('faraStoc')}
                style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 8, padding: '8px 4px', fontWeight: 600, borderBottom: '1px solid #eee' }}>
                <span>{extinse.has('faraStoc') ? '\u25be' : '\u25b8'}</span>
                <span>Fara stoc</span>
                <span style={{ fontWeight: 400, color: '#888', fontSize: 13 }}>({grupuri.faraStoc.length} materiale)</span>
              </div>
              {extinse.has('faraStoc') && (
                <table>
                  <thead>
                    <tr><th>Cod</th><th>Denumire</th><th>UM</th><th>Prag alerta</th><th>Pret curent</th><th></th></tr>
                  </thead>
                  <tbody>{grupuri.faraStoc.map(randMaterial)}</tbody>
                </table>
              )}
            </div>
          )}

          {grupuri.magazii.length === 0 && grupuri.faraStoc.length === 0 && <p>Niciun material in nomenclator.</p>}
        </div>
      )}

      {showModal && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal" onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <h2>{editId ? 'Editeaza material' : 'Material nou'}</h2>
              <button type="button" className="modal-close" onClick={() => setShowModal(false)}>&times;</button>
            </div>
            <form onSubmit={salveaza}>
              <div className="modal-body">
                {editId && (
                  <p style={{ fontSize: 13, color: '#888', marginTop: 0 }}>Cod: <strong>{codEditat}</strong></p>
                )}
                <div className="field-row">
                  <div className="field">
                    <label>Denumire *</label>
                    <input value={form.denumire} onChange={e => setForm({ ...form, denumire: e.target.value })} required autoFocus />
                  </div>
                </div>
                <div className="field-row">
                  <div className="field">
                    <label>Unitate de masura *</label>
                    <select value={form.um} onChange={e => setForm({ ...form, um: e.target.value })}>
                      {UNITATI.map(u => <option key={u} value={u}>{u}</option>)}
                    </select>
                  </div>
                  <div className="field">
                    <label>Prag alerta (0 = fara alerta)</label>
                    <input type="text" inputMode="decimal" value={form.pragAlerta}
                      onChange={e => setForm({ ...form, pragAlerta: filtreazaCantitate(e.target.value) })} />
                  </div>
                </div>
                <div className="field-row">
                  <div className="field">
                    <label>Pret curent</label>
                    <input type="text" inputMode="decimal" value={form.pretCurent}
                      onChange={e => setForm({ ...form, pretCurent: filtreazaCantitate(e.target.value) })} />
                    <p style={{ fontSize: 12, color: '#888', margin: '4px 0 0' }}>
                      Se actualizeaza automat la fiecare Intrare noua - schimba-l manual aici doar daca vrei sa-l corectezi.
                    </p>
                  </div>
                </div>
              </div>
              <div className="modal-actions">
                <button type="button" className="btn secondary" onClick={() => setShowModal(false)}>Anuleaza</button>
                <button type="submit" className="btn">Salveaza</button>
              </div>
            </form>
          </div>
        </div>
      )}

      <Toast message={toast?.message} type={toast?.type} onClose={() => setToast(null)} />
    </div>
  );
}
